import CartItem from "@/components/atoms/CartItem/CartItem";
import type { CartItemMaybeHooked } from "@/lib/hooks/useSelection/cart/useItems";
import { useCartPreOrder } from "../Cart/hooks/useCartPreorder";

const CartItems = ({
  items,
  showQuantity = false,
}: {
  items: CartItemMaybeHooked[] | null;
  showQuantity?: boolean;
}) => {
  const { preOrderIds } = useCartPreOrder();

  return (
    <>
      {items?.map((item, i) => {
        if (!item.id) return null;
        const isPreOrder =
          preOrderIds.length &&
          item?.itemId &&
          preOrderIds?.includes(item.itemId.split("-")[0]);

        return (
          <CartItem
            item={item}
            key={`${item.line}-${i}`}
            quantity={showQuantity}
            isPreorder={Boolean(isPreOrder)}
          />
        );
      })}
    </>
  );
};

export default CartItems;
